const COLORS = {
  BLACK: '#000000',
  DARK_GREY: '#222222',
  DARK_GREY_01: '#333333',
  DARK_GREY_02: '#58595b',
  DARK_GREY_03: '#444444',
  DARK_GREY_04: '#2d2d2d',
  INPUT_GREY: '#58595B',
  DISABLED_GREY: '#d1d2d2',
  DISABLED_GREY_LIGHT: '#515151',
  GREY_01: '#939598',
  GREY_02: '#bbbec0',
  PURPLE: '#413892',
  PURPLE_03: '#9f9bc8',
  PURPLE_04: '#3F51B8',
  BLUE: '#00AAE2',
  BLUE_01: '#175B9E',
  BLUE_03: '#3f51b5',
  BLUE_04: '#1488CC',
  WHITE: '#ffffff',
  ORANGE: '#f9a134',
  DARK_ORANGE: '#E84C07',
  LIGHT_ORANGE: '#FFCA36',
  GREEN: '#76c67c',
  NAVY: '#175b9e',
  RED: '#e4001c',
  RED_01: '#FE0061',
  PINK: '#fe0061',
  ERROR: '#f44336',
  YELLOW: '#F4DE59',
  LIGHT_GREY: '#d3d4d5',
  LIGHTGREEN: '#26a27b',
  SR_GREEN: '#0A8390',
  SR_GREEN_10: '#6CBFA2',
  SR_WHITE_10: '#fafafa',
  SR_PURPLE_WHITE_10: '#edebf5',
  SR_PURPLE_WHITE_50: '#c0bfd2',
  SR_WHITE_50: '#eaeaf0',
  SR_PURPLE: '#27135F',
  SR_LILAC: '#8D779F',
  SR_GUNMETAL_GREY_100: '#1e373f',
  SR_GUNMETAL_GREY_80: '#4b5f65',
  SR_GUNMETAL_GREY_90: '#354b52',
  SR_GUNMETAL_GREY_60: '#78878c',
  SR_GUNMETAL_GREY_40: '#a5afb2',
  SR_GUNMETAL_GREY_20: '#d2d7d9',
  SR_LINK_WATER_100: '#d2edf4',
  SR_LINK_WATER_80: '#dbf1f6',
  SR_LINK_WATER_60: '#e4f4f8',
};
// This will add extra key to COLOR object.
COLORS.WARNING = COLORS.YELLOW;

export default COLORS;
